import { getLeadSource } from "routes/leads/leadSourceRegistry";

// Resolves a lead row to its provider-specific detail route. The row's
// `source` is the provider's registry key, so this surface stays decoupled
// from any one provider: an unregistered source (or a row without the ids the
// link needs) returns null and the ID column falls back to plain text. Adding
// GTM later is one new registry entry.
export const leadDetailHref = row => {
  const source = getLeadSource(row?.source);
  if (!source || row?.account_id == null || row?.source_record_id == null) {
    return null;
  }
  return `/leads/${source.key}/${row.account_id}/lead/${row.source_record_id}/overview`;
};
